import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_free_forms_translation_domain_translations_list = _resolveComponent("free-forms-translation-domain-translations-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_select, {
      "model-value": _ctx.localModel,
      "lazy-rules": "",
      options: _ctx.translationOptions,
      rules: [_ctx.requiredRule],
      label: _ctx.label+'*',
      outlined: "",
      dense: "",
      "onUpdate:modelValue": _ctx.onUpdate,
      "emit-value": "",
      "map-options": "",
      "hide-bottom-space": "",
      "options-html": ""
    }, null, 8, ["model-value", "options", "rules", "label", "onUpdate:modelValue"]),
    _createVNode(_component_free_forms_translation_domain_translations_list, { translations: _ctx.translationDomainTranslations }, null, 8, ["translations"])
  ], 64))
}